<template>
  <span>
    <span @dblclick='showSelectionDialogMD'>
      <el-input v-model='displayVal' :placeholder='"请双击后选择"' :disabled='disabled' :readonly='readonly'
        size='mini' class='filterInput' suffix-icon='sys sys-search'>
      </el-input>
    </span>

    <el-dialog v-dialogDrag title='选择数据' :visible.sync='showSelectionDialog' :width='dialogWidth' top='10px'
      append-to-body>
      <!-- 工具栏 -->
      <div class='navbar' style='margin-top: -35px;'>
        <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
          @click='deepRefreshMainTableContent'>
          刷 新
        </el-button>

        <el-button type='primary' icon='sys sys-clear' class='navbarbtn'
          @click='clearSelected'>
          清 除
        </el-button>

        <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
          :showColumnSetDialog='mainTable.showColumnSetDialog'
          :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
          :columnInfo='mainTable.userColumnInfo'
          :tableInfo='mainTable.userTableInfo'
          @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
          @saveUserTableColumn='mainTableSaveUserTableColumn'
          @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
          @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
        </TableColumnSet>

        <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
          :showFilterSetDialog='mainTable.showFilterSetDialog'
          :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
          :filterInfo='mainTable.userFilterInfo'
          :columnInfo='mainTable.columnInfo'
          @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
          @saveUserTableFilter='mainTableSaveUserTableFilter'
          @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
          @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
        </TableFilterSet>

        <TableFilter :filterLoading='mainTable.FilterLoading'
          :showFilterDialog='mainTable.showFilterDialog'
          :changeShowFilterDialog='mainTable.changeShowFilterDialog'
          :filterInfo='mainTable.filterInfo'
          :columnInfo='mainTable.columnInfo'
          :getSpecialStringArray='mainTableGetSpecialStringArray'
          @showFilterDialogMD='mainTableShowFilterDialogMD'
          @filter='mainTableFilter'>
        </TableFilter>

        <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
          :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
          :getSpecialStringArray='mainTableGetSpecialStringArray'
          :columnInfo='mainTable.columnInfo'
          :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
        </TableFilterOutDisplay>
      </div>

      <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
        :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
        :page-size='mainTable.pageSize' :page='mainTable.page'
        :total='mainTable.total' v-loading='mainTable.Loading'
        :row-style='mainTableRowStyle' :height='height'
        :showOperationsColumn='false'
        :showSelectionColumn='false'
        :showDefaultExpandColumn='true' :showExpandColumn='false'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @row-dblclick='mainTableRowDblclick'
        @selection-change='mainTableSelectionChange'
        @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
        @sort-change='mainTableSortChange'>
      </Table>
    </el-dialog>
  </span>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'

export default {
  name: 'TableSelect',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay
  },
  props: {
    tableCode: {
      default: '',
      type: String
    },
    getSpecialStringArray: {
      default: null,
      type: Function
    },
    rowStyle: {
      default: function () {
        return {}
      },
      type: [Object, Function]
    },
    height: {
      default: '300px',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    readonly: {
      default: true,
      type: Boolean
    },
    dialogWidth: {
      default: '80%',
      type: String
    },
    value: {
      default: '',
      type: String
    },
    displayValue: {
      default: '',
      type: String
    },
    returnCode: {
      default: '',
      type: String
    },
    displayCode: {
      default: '',
      type: String
    },
    displayName: {
      default: '',
      type: String
    },
    customFilterStr: {
      default: '',
      type: String
    }
  },

  data: function () {
    return {
      mainTable: {
        tableCode: '',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 20,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,
        customFilterStr: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false
      },

      displayVal: '',
      showSelectionDialog: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    },
    displayValueComputed: function () {
      return `${this.displayValue}`
    }
  },

  watch: {
    displayValueComputed: function (newVal, oldVal) {
      this.displayVal = newVal
    },
    customFilterStr: function (newVal, oldVal) {
      this.mainTable.customFilterStr = newVal
      this.refreshMainTableContent()
    }
  },

  created: async function () {
    const that = this
    that.mainTable.tableCode = that.tableCode
    that.displayVal = that.displayValue
    that.mainTable.customFilterStr = that.customFilterStr
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      const that = this
      if (typeof (getSpecialStringArray) === 'function') {
        return that.getSpecialStringArray(columnCode)
      }
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      const that = this
      if (typeof (rowStyle) === 'function') {
        return that.rowStyle(data, rowIndex)
      }
      return {}
    },

    // 选择弹出框显示事件
    showSelectionDialogMD: function () {
      const that = this
      if (that.disabled) return
      that.showSelectionDialog = true
    },

    // 行双击选中事件
    mainTableRowDblclick: function (row, event) {
      const that = this
      that.displayVal = (row[that.displayCode] && row[that.displayCode] !== '' ? row[that.displayCode] : '') + (that.displayName ? ((row[that.displayName] && row[that.displayName] !== '' ? ('(' + row[that.displayName] + ')') : '')) : '')
      that.$emit('input', row[that.returnCode])
      that.$emit('change', row)
      that.showSelectionDialog = false
    },

    clearSelected: function () {
      const that = this
      that.displayVal = ''
      that.$emit('input', '')
      that.$emit('change', {})
      that.showSelectionDialog = false
    },

    setSelected: function (value, displayVal) {
      const that = this
      that.displayVal = displayVal
      that.$emit('input', value)
      that.showSelectionDialog = false
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
</style>
